import { type Client } from '@api/functions';
import { AuthMethod, type BaseOAuthMethod, type OAuthMethod, UserGender } from '@shared/types/user';

import { ApiTypes, client as defaultClient, getUrl } from '../client';

export async function login({
    usernameEmail,
    password,
    isRememberUser,
    recaptchaToken,
    recaptchaTokenV2,
    cookiesAllowedAt,
}: ApiTypes.Login) {
    return defaultClient.POST('/auth/login', {
        body: {
            usernameEmail,
            password,
            isRememberUser,
            recaptchaToken,
            recaptchaTokenV2,
            cookiesAllowedAt,
        },
    });
}

export async function signup({
    password,
    email,
    gender,
    cookiesAllowedAt,
    recaptchaToken,
    recaptchaTokenV2,
}: ApiTypes.Signup) {
    return defaultClient.POST('/auth/signup', {
        body: {
            password,
            gender,
            email,
            cookiesAllowedAt,
            recaptchaToken,
            recaptchaTokenV2,
        },
    });
}

export async function logout() {
    return defaultClient.POST('/auth/logout', {
        body: {},
    });
}

export async function getCurrent(client?: Client) {
    return (client ?? defaultClient).GET('/app/auth/current', { params: {} });
}

export async function authPath(url: string) {
    return defaultClient.GET('/app/auth/path', { params: { query: { url } } });
}

export async function incarnateLogin({ incarnateUserId }: ApiTypes.IncarnateLogin) {
    return defaultClient.POST('/auth/incarnate/login', { body: { incarnateUserId } });
}

export async function incarnateLogout() {
    return defaultClient.POST('/auth/incarnate/logout', { body: {} });
}

export function oauth(oauthMethod: BaseOAuthMethod, gender?: UserGender, cookiesAllowedAt?: string) {
    const windowReference = window;
    if (windowReference) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        windowReference.location.href = getUrl(`/auth/${oauthMethod}`, {
            ...(gender ? { gender } : {}),
            ...(cookiesAllowedAt ? { cookiesAllowedAt } : {}),
        });
    }
}

export function oauthOneTap(jwt: string, cookiesAllowedAt?: string) {
    return defaultClient.GET(`/auth/${AuthMethod.GoogleOneTap}`, {
        headers: { Authorization: `Bearer ${jwt}` },
        params: {
            query: { cookiesAllowedAt },
        },
    });
}

export async function oauthVerify(
    oauthMethod: OAuthMethod,
    { password }: ApiTypes.OAuthVerify
) {
    return defaultClient.POST('/auth/{oauthMethod}/verify', {
        params: { path: { oauthMethod } },
        body: { password },
    });
}
